import { useEffect, useState } from "react";
import MainLayout from "../../layouts/main-layout";
import { Box, Container } from "@mui/material";
import 'bootstrap/dist/css/bootstrap.min.css';
import './form.css';

const FormDemo = () => {
  const [username, setUsername] = useState('');
  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [gender, setGender] = useState('Other');
  const [country, setCountry] = useState('');
  const [isAcceptAgreement, setIsAcceptAgreement] = useState(false);
  const [summaryText, setSummaryText] = useState('');

  const [currentTime, setCurrentTime] = useState<string>("");
  const [timeCounter, setTimeCounter] = useState<number>(0);

  

  useEffect(() => {
    const renderTime = () => {
      setCurrentTime(new Date().toLocaleString());
      setTimeCounter(prevCounter => prevCounter + 1);
    };

    renderTime(); // Initialize immediately
    const intervalId = setInterval(renderTime, 1000);
    return () => clearInterval(intervalId); // Cleanup interval on component unmount
  }, []);


  const handleSubmit = (e:any) => {
    e.preventDefault();
    // Add your logic here for form submission
    console.log('Submitted:', { username, firstname, lastname });
    // You can perform further actions like API calls or state updates
    setSummaryText(`
        username: ${username}
        firstname: ${firstname}
        lastname: ${lastname}
        gender: ${gender}
        country: ${country}`);
    setIsAcceptAgreement(false);
    setUsername('');
    setFirstname('');
    setLastname('');
    setGender('Other');
    setCountry('');
  };

  const handleAlertConfirm = () => {
    const result = window.confirm('Pleasee select ok / cancel?');
    if (result) {
      console.log('User clicked OK');
    } else {
      console.log('User clicked Cancel');
    }
  };
  
  return (
    <MainLayout>
      <Box
        sx={{
          bgcolor: 'background.paper',
          pt: 12,
          pb: 6,
        }}
      >
        <Container maxWidth="lg">
          <h1 className="text-center">Form Demo</h1>
          <div id="current-time" data-testid="current-time">Time: {currentTime} - {timeCounter}</div>
          <form className='form' onSubmit={handleSubmit}>
            {summaryText != '' && (
              <div className={`alert alert-success`}>
                <pre style={{ textAlign: 'left' }} >
                  {summaryText}
                </pre>
              </div>
            )}
            <div className='form-row'>
              <label htmlFor={'username'} className='form-label'>
                username*
              </label>
              <input
                id="username"
                type="text"
                name='username'
                className='form-input'
                value={username}
                onChange={(e) => {
                  setUsername(e.target.value);
                }}
                required
              />
            </div>
            <div className='form-row'>
              <label htmlFor={'firstname'} className='form-label'>
                firstname*
              </label>
              <input
                type="text"
                name='firstname'
                className='form-input'
                value={firstname}
                onChange={(e) => {
                  setFirstname(e.target.value);
                }}
                required
              />
            </div>
            <div className='form-row'>
              <label htmlFor={'lastname'} className='form-label'>
                lastname*
              </label>
              <input
                type="text"
                className='form-input lastname'
                value={lastname}
                onChange={(e) => {
                  setLastname(e.target.value);
                }}
                required
              />
            </div>
            <div className='form-row'>
              <label htmlFor='gender' className='form-label'>
                Gender
              </label>
              <div className="radio">
                <label>
                  <input
                    name="gender"
                    type="radio"
                    value="Male"
                    checked={gender === "Male"}
                    onChange={(e) => { setGender(e.target.value); }}
                    data-testid='male'
                  />
                  &nbsp;&nbsp;Male
                </label>
              </div>
              <div className="radio">
                <label>
                  <input
                    name="gender"
                    type="radio"
                    value="Female"
                    checked={gender === "Female"}
                    onChange={(e) => { setGender(e.target.value); }}
                    data-testid='female'
                  />
                  &nbsp;&nbsp;Female
                </label>
              </div>
              <div className="radio">
                <label>
                  <input
                    name="gender"
                    type="radio"
                    value="Other"
                    checked={gender === "Other"}
                    onChange={(e) => { setGender(e.target.value); }}
                    data-testid='other'
                  />
                  &nbsp;&nbsp;Other
                </label>
              </div>
            </div>
            <div className='form-row'>
              <label className='form-label'>
                Country*
              </label>
              <select value={country} onChange={(e) => { setCountry(e.target.value); }} required>
                <option value="">Select</option>
                <option value="TH">Thailand</option>
                <option value="PH">Philippines</option>
                <option value="HK">Hongkong</option>
                <option value="VN">Vietnam</option>
              </select>
            </div>
            <div className='form-row'>
              <input type="checkbox" checked={isAcceptAgreement} onChange={() => { setIsAcceptAgreement(!isAcceptAgreement); }}/> Accept agreement
              <br /><br />
              <button type='submit' className='btn btn-block btn-primary' data-testid='submit' disabled={!isAcceptAgreement}>
                submit
              </button>
            </div>
            <hr></hr>
            <div className='form-row'>
            <label className='form-label'>
                File:
              </label>
              <a href="demo.txt" download>Download file</a>
            </div>
            <div className='form-row'>
              <label className='form-label'>
                Alert:
              </label>
              <button className='btn btn-block btn-danger' data-testid='alert-1' onClick={() => { alert('Button clicked!');  }} >
                alert normal
              </button>
              <br></br><br></br>
              <button className='btn btn-block btn-danger' data-testid='alert-2' onClick={handleAlertConfirm} >
                alert confirm
              </button>
            </div>
          </form>

          <form className='form'>
            <h2 className="text-center">iFrame</h2>
            <iframe src="/todo-list" title="W3Schools Free Online Web Tutorials" width={400} height={400}>
          </iframe>
          </form>
        </Container>
      </Box>
    </MainLayout>
  )
};
export default FormDemo;